import type { RouteObject } from 'react-router';
import { AuctionPage } from './AuctionPage';
import { BackorderPage } from './BackorderPage';
import { DropPage } from './DropPage';
import { RdeDepositPage } from './compliance/RdePage';

/** Detail routes (paths without a leading slash). */
export const MARKET_ROUTES: RouteObject[] = [
  { path: 'auctions/:id', element: <AuctionPage /> },
  { path: 'backorders/:id', element: <BackorderPage /> },
  { path: 'drops/:id', element: <DropPage /> },
  { path: 'compliance/icann/rde/:id', element: <RdeDepositPage /> },
];
